import { AgendaPage } from './AgendaPage';

// Keep the existing entry point used by the series form, with one shared Agenda.
export function AgendaWeeklyPage() {
  return <AgendaPage initialViewMode="week" />;
}
